import { render, staticRenderFns } from "./core-description-column.vue?vue&type=template&id=262226a9"
import script from "./core-description-column.vue?vue&type=script&lang=js"
export * from "./core-description-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports